// ROOT
export const HOME_PATH = '/';
export const LOGIN_PATH = '/login';
export const LANDING_PATH = '/landing';
export const PASSWORD_RECOVERY_PATH = '/password-recovery';
export const RESET_PASSWORD_PATH = '/reset-password';
export const RESET_PASSWORD_SUCCESS_PATH = '/reset-password/success';
export const RESET_PASSWORD_EXPIRED_PATH = '/reset-password/expired';
export const EMAIL_CONFIRMATION_PATH = '/email-confirmation';

// Nutrition
export const NUTRITION_PATH = '/nutrition';
export const MY_FOODS_PATH = '/nutrition/foods';
export const FORMULA_PATH = '/nutrition/formula';
export const FOOD_DETAILS_PATH = '/nutrition/foods/:id';
export const INGREDIENT_DETAILS_PATH = '/nutrition/ingredients/:id';

// Health
export const HEALTH_PATH = '/health';
export const HEALTH_CONNECTIONS_PATH = '/health/connections';
export const HEALTH_CONDITIONS_PATH = '/health/connections/:condition';
export const HEALTH_CONDITION_DETAIL_PATH =
  '/health/connections/:condition/:id';
export const ACTIVE_MICROBES_PATH = '/active-microbes';
export const HEALTH_CONTRIBUTING_SCORE = '/health/score/contributing-score';
export const L2_CONTRIBUTING_SCORE = '/health/score/contributing-score/:id';
export const L2_SCORE_PATH = '/health/score/:id';
export const L3_DETAIL_PATH = 'health/l3/:id';
export const L4_DETAIL_PATH = 'health/l4/:id';
export const BIO_AGE_PATH = '/health/biological-age';
export const INFLAMMAGING_PATH = '/health/inflammaging';
export const GUT_MICROBIOME_PATH = '/health/gut-microbiome';
export const ORAL_MICROBIOME_PATH = '/health/oral-microbiome';
export const GUT_RICHNESS_PATH =
  '/health/gut-microbiome/gut-richness-diversity';
export const ORAL_RICHNESS_PATH =
  '/health/oral-microbiome/oral-richness-diversity';
export const GUT_DYBIOSIS_PATH = '/health/gut-microbiome/gut-dybiosis';
export const ORAL_DYBIOSIS_PATH = '/health/oral-microbiome/oral-dybiosis';
export const IMPROVE_MY_SCORE_DETAIL = 'health/improve-my-score/:id';

//HomePage
export const RESULTS_READY_PATH = '/results-ready';
export const BOOSTERS_AND_BLOCKERS_PATH = '/boosters-and-blockers';
export const BLOOD_SUGAR_PATH = '/boosters-and-blockers/blood-sugar';
export const PLANT_VIRUS_PATH = '/boosters-and-blockers/plant-virus';
export const MOOD_MEMORY_FOCUS_PATH = '/boosters-and-blockers/:id';
export const COLLECT_SAMPLE_PATH = '/collect-sample';
export const TRISYNBIOTIC_DETAIL_PATH = '/trisynbiotic';
export const BOOSTER_BLOCKER_DETAIL = '/boosters-and-blockers/detail';

// Shop
export const SHOP_PATH = '/shop';
export const PRODUCT_DETAIL_PAGE_PATH = '/shop/product/:id';
export const ADD_OR_REMOVE_PRODUCTS = '/shop/add-or-remove-products';

// Questionnaires
export const QUESTIONNAIRES_PATH = '/questionnaires';
export const QUESTIONNAIRE_DETAILS_PATH = '/questionnaires/:groupId';
export const QUESTIONNAIRE_QUESTIONS_PATH =
  '/questionnaires/:groupId/questions';
export const QUESTIONNAIRE_SUCCESS_PATH = '/questionnaires/success';
export const QUESTIONNAIRE_COMPLETED_PATH = '/questionnaires/completed';

// SMP
export const SMP_PATH = '/smp';
export const SMP_ORDER_DETAILS_PATH = '/smp/order-details';
export const SMP_SKIP_NEXT_ORDER_PATH = '/smp/skip-next-order';
export const SMP_ADD_REMOVE_PRODUCTS_PATH = '/smp/add-remove-products';
export const SMP_PAUSE_SUBSCRIPTION_PATH = '/smp/pause-subscription';
export const SMP_CANCEL_SUBSCRIPTION_PATH = '/smp/cancel-subscription';
export const SMP_REACTIVATE_PATH = '/smp/reactivate';
export const SMP_FUTURE_ORDERS_PATH = '/smp/future-orders';
export const SMP_ORDER_HISTORY_PATH = '/smp/order-history';
export const SMP_ORDER_HISTORY_DETAILS_PATH = '/smp/order-history/:orderId';
export const SMP_CHANGE_ADDRESS_PATH = '/smp/change-address';
export const SMP_PAYMENT_METHODS_PATH = '/smp/payment-methods';
export const SMP_RESUME_SUBSCRIPTION_PATH = '/smp/resume-subscription';
export const SMP_DISCOUNT_CODE_PATH = '/smp/discount-code';
export const SMP_I_NEED_IT_SOONER_PATH = '/smp/i-need-it-sooner';

export const ACCOUNT_MANAGEMENT_PATH = '/account';
export const SETTINGS_PATH = '/account/settings';
export const MY_HEALTH_HISTORY_PATH = '/account/health-history';
export const UPDATE_PASSWORD_PATH = '#';
export const UPDATE_MEDICAL_HISTORY_PATH = '#';
export const TRACK_SAMPLE_STATUS_PATH = '/account/samples';
export const SAMPLE_DETAILS_PATH = '/account/samples/:id';
export const MY_REPORTS_PATH = '/account/reports';
export const ORDER_DETAIL_PATH = '/account/order-detail/:orderNumber';

// Tests
export const REGISTER_TEST_PATH = '#';

// Studies
export const STUDIES_PATH = '#';

// Vie
export const VIE_CHAT_PATH = '#';
// Registration
const REGISTRATION = '/registration';
export const REGISTRATION_LANDING = `${REGISTRATION}`;
export const REGISTRATION_KIT_ID = `${REGISTRATION}/kit-id`;
export const REGISTRATION_ACCOUNT_CREATION = `${REGISTRATION}/account-creation`;
export const REGISTRATION_PERSONAL_INFORMATION = `${REGISTRATION}/personal-information`;
export const REGISTRATION_CONTACT_INFORMATION = `${REGISTRATION}/contact-information`;
export const REGISTRATION_CONFIRMATION = `${REGISTRATION}/confirmation`;
export const REGISTRATION_PENDING_KIT = `${REGISTRATION}/pending-kit`;
export const REGISTRATION_BUNDLE_INFO = `${REGISTRATION}/bundle-message`;
export const REGISTRATION_ADDRESS_CONFIRMATION = `${REGISTRATION}/address-confirmation`;
export const REGISTRATION_USER_CONSENT = `${REGISTRATION}/terms-of-services`;

// Cancer Detect
export const CANCER_DETECT_PATH = '/cancer-detect';
export const MAINTENANCE_PATH = '/maintenance';
export const RECIPES_PATH = '/recipes';
export const WRAPPED_V2_PATH = '/wrapped/v2';
